/**
 * Domínio: página de Plugins.
 *
 * A própria tela que lista plugins é extensível por plugin — é o que permite,
 * por exemplo, uma loja/catálogo aparecer ali sem que o app conheça a loja.
 *
 * Acesse via `plugins.slots.PAGE_PANEL`.
 */

export const plugins = {
  events: {},
  /** Slots de render. */
  slots: {
    /**
     * Área de botões do cabeçalho, ao lado de "Atualizar" e "Adicionar Plugin
     * Remoto". Para ações que valem para a página inteira.
     */
    PAGE_HEADER: "plugins-page-header",
    /**
     * Faixa de largura total ENTRE o cabeçalho e a lista de plugins. É o ponto
     * para painéis inteiros — uma loja, um aviso de atualização disponível, um
     * resumo de consumo.
     *
     * Diferente dos demais: aqui se espera `mountJsx`/`htmlPage`, não um botão.
     */
    PAGE_PANEL: "plugins-page-panel",
    /**
     * ABA própria na página de Plugins, ao lado de "Instalados" e "Padrões".
     *
     * O plugin declara uma action neste slot e o app cria a aba: `label` vira o
     * título e o CONTEÚDO é servido pelo próprio plugin (o app faz POST no
     * `endpoint` e injeta o HTML devolvido, no contexto da sessão — sem iframe).
     *
     * É o caminho para páginas inteiras: uma loja, um relatório de consumo.
     * Diferente do PAGE_PANEL, que divide espaço com a lista; aqui a tela é toda
     * do plugin enquanto a aba estiver selecionada.
     */
    PAGE_TABS: "plugins-page-tabs",
    /**
     * Rodapé do card de UM plugin, junto de "Configurar". Recebe o plugin
     * daquele card no context — serve para ações por plugin (ex: "atualizar
     * para a versão 2.1", "ver na loja").
     */
    CARD_ACTIONS: "plugins-card-actions",
    /**
     * Linha de etiquetas do card, junto das capacidades. Para marcadores
     * curtos: "atualização disponível", "instalado pela loja", "expira em 3d".
     */
    CARD_BADGE: "plugins-card-badge",
  },
  hooks: {},
  /**
   * CONTRATO DE DADOS dos slots — o que o `context` entrega. Fonte única de
   * verdade: o call-site preenche estes campos e o plugin lê sabendo o que
   * esperar. Mantenha alinhado com o `context={...}` da página de Plugins.
   */
  slotContext: {
    "plugins-page-header": {
      total: "number",              // quantos plugins estão listados
      instalados: "string[]",       // ids dos plugins instalados nesta empresa
      ehMaster: "boolean",          // usuário é super admin da empresa master
    },
    "plugins-page-panel": {
      total: "number",
      instalados: "string[]",
      ehMaster: "boolean",
    },
    // Mesmo contrato da página — a aba recebe os mesmos dados no POST que
    // busca o seu conteúdo.
    "plugins-page-tabs": {
      total: "number",
      instalados: "string[]",
      ehMaster: "boolean",
    },
    "plugins-card-actions": {
      pluginId: "string",
      channel: "string?",           // ausente em plugin sem capability de canal
      displayName: "string",
      version: "string?",
      isRemote: "boolean",
      offline: "boolean",
      baseUrl: "string?",
      provides: "object",
      plugin: "object",             // o objeto COMPLETO do plugin (fallback)
    },
    // Mesmo contrato do rodapé — a etiqueta recebe os mesmos dados do card.
    "plugins-card-badge": {
      pluginId: "string",
      channel: "string?",
      displayName: "string",
      version: "string?",
      isRemote: "boolean",
      offline: "boolean",
      baseUrl: "string?",
      provides: "object",
      plugin: "object",
    },
  },
} as const;
